import { StyleSheet, Platform } from 'react-native';

import { Colors, Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes';

export default StyleSheet.create({
  collapseButton: {
    borderWidth: 0,
    height: 22,
    marginTop: 12,
  },
  cardStyle: theme => ({
    backgroundColor: theme.colors.cardBackgroundColor,
    borderRadius: 6,
    paddingVertical: 15,
    shadowColor: Colors.blackThree,
    shadowOffset: { width: 0, height: 3 },
    shadowOpacity: 0.16,
    shadowRadius: 8,
    elevation: 4,
  }),
  collapseButtonText: theme => ({
    color: theme.colors.showMoreColor,
  }),
  headline: {
    paddingBottom: 10,
  },
  bottomBorder: theme => ({
    borderBottomWidth: 1,
    borderBottomColor: theme.colors.borderColorFour,
  }),
  notCollapsedItem: {
    paddingVertical: 16.5,
  },
  collapsedItem: theme => ({
    borderBottomWidth: 1,
    borderBottomColor: theme.colors.borderColorFour,
    marginLeft: 48,
    marginBottom: 10,
    paddingBottom: 10,
  }),
  totalText: theme => ({
    fontSize: 16,
    color: theme.colors.textColorThree,
    ...Fonts.type.bold,
  }),
  firstItem: {
    marginTop: 10,
  },
  ctaContainer: {
    marginVertical: 25,
  },
  ctaText: {
    marginTop: Platform.OS == 'ios' ? 3 : 0,
  },
  lottieViewStyle: {
    marginTop: 3,
  },
  loaderContainer: {
    width: '100%',
    paddingHorizontal: 10,
    overflow: 'hidden',
  },
  row: {
    flexDirection: 'row',
    flex: 1,
    justifyContent: 'space-between',
  },
});
